//frontend\gsdashboard\src\components\OceanWaves.js
import React from 'react';
import './OceanWaves.css';

function OceanWaves() {
  return (
    <div className="ocean-wrapper">
      <div className="wave wave1"></div>
      <div className="wave wave2"></div>
      <div className="wave wave3"></div>
    </div>
  );
}

export default OceanWaves;